// async function imgToUrl(url) {
//     if (Array.isArray(url)) {
//         const dataUrls = await Promise.all(
//             url.map(async (imageUrl) => {
//                 try {
//                     const response = await fetch(imageUrl);
//                     const blob = await response.blob();
//                     const dataUrl = await new Promise((resolve) => {
//                         const reader = new FileReader();
//                         reader.onloadend = () => resolve(reader.result);
//                         reader.readAsDataURL(blob);
//                     });
//                     let name = imageUrl.split("/");
//                     name = name[name.length - 1];
//                     return new File([blob], name, { type: blob.type });
//                 } catch (error) {
//                     console.error(`Error: ${error}`);
//                     return null;
//                 }
//             })
//         );
//         return (dataUrls);
//     } else {
//         try {
//             const response = await fetch(url);
//             const blob = await response.blob();
//             const dataUrl = await new Promise((resolve) => {
//                 const reader = new FileReader();
//                 reader.onloadend = () => resolve(reader.result);
//                 reader.readAsDataURL(blob);
//             });
//             let name = url.split("/");
//             name = name[name.length - 1];
//             return new File([blob], name, { type: blob.type });
//         } catch (error) {
//             console.error(`Error: ${error}`);
//             return null;
//         }
//     }

// }
async function imgToUrl(url) {
    //console.log(url);
    let urlImg = typeof url == 'object' ? Object.values(url)[0] : url;
    if (!['', null, undefined].includes(urlImg)) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(urlImg);
                const blob = await response.blob();

                const reader = new FileReader();
                reader.onload = () => {
                    const dataurl = reader.result;
                    const filename = urlImg.substring(urlImg.lastIndexOf("/") + 1);
                    const file = new File([blob], filename, { type: blob.type });

                    resolve({ file, dataurl });
                };

                reader.readAsDataURL(blob);
            } catch (error) {
                reject(error);
            }
        });
    }
}

export { imgToUrl }